import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
import React from "react";
var __jsx = React.createElement;
const MoneySymbolIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M0.25 15.8458C0.480963 18.4506 2.61398 20.2978 5.86105 20.5371V22.4375H7.49137V20.5371C11.0373 20.258 13.2383 18.2911 13.2383 15.3806C13.2383 12.8954 11.7574 11.4601 8.61902 10.6495L7.49137 10.3571V4.41654C9.24398 4.58931 10.426 5.53288 10.7249 6.9416H13.0209C12.7628 4.44312 10.6162 2.649 7.49137 2.44965V0.5625H5.86105V2.48952C2.83135 2.84834 0.752685 4.78865 0.752685 7.42003C0.752685 9.69259 2.26074 11.3007 4.91002 11.9784L5.86105 12.2309V18.5303C4.06768 18.2645 2.83135 17.2811 2.53246 15.8458H0.25ZM5.54857 9.85207C3.91824 9.44008 3.04873 8.56295 3.04873 7.327C3.04873 5.85184 4.1492 4.76207 5.86105 4.4697V9.9318L5.54857 9.85207ZM8.03482 12.7758C10.0456 13.2808 10.9286 14.1181 10.9286 15.5401C10.9286 17.2545 9.63797 18.3974 7.49137 18.5702V12.6429L8.03482 12.7758Z",
    fill: color
  }));
};
export default MoneySymbolIcon;